import style from "styled-components";
import axios from "axios";
import React, { useState, useEffect } from "react";
import {
  Form,
  InputContainer,
  ButtonsContainer,
  Button,
  ErrorSpan,
  ButtonsContainerTuPay,
  AmountButton
} from "../DepositElements";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../../utils/tools";
import { useSelector } from "react-redux";
import { selectCurrency } from "../../../features/user/userSlice";
import COINSPAID from '../../../assets/images/ALPHAPO.svg';
import Rcoinspaid from '../../../assets/images/RETIRA CON ALPHAPO-01.svg';

const FormCoinspaidRetiro = ({
 form,
  handleChange,
  handleClose,
  solicitarRetiro,
  loading,
}) => {
  const [t] = useTranslation("global");
  const moneda = useSelector(selectCurrency);
  const [Cryptos, setCryptos] = useState([]);
  const [monto, setMonto] = useState(0);
  const [blur, setBlur] = useState(false);
  const [showMemoInput, setShowMemoInput] = useState(false);
  const validCurrencies = ['$','ARS', 'Bs.S', 'VES', 'DOP', 'MXN', 'COP', 'CLP', 'BOB', 'PEN'];
  const [monedaAux, setmonedaAux] = useState(validCurrencies.includes(moneda) ? 'USD' : moneda);

  useEffect(() => {
    const fetchCryptos = async () => {
      const url = `https://app.masterbets365.com/API/CoinsPaid/index.php/Api/getCryptocurrencies/${monedaAux}`;
      const response = await axios.get(url);
      if (response.data.code === 200) {
        const CryptosHabilitadas = response.data.cryptocurrencies;
        setCryptos(CryptosHabilitadas);
      }
    };
    fetchCryptos();
  }, []); // Se ejecutará solo una vez al montar el componente

   const handleMonto = (e) => {
    setBlur(true);
    handleChange(formatNumber(e));
    setMonto(parseFloat(e.target.value.replaceAll(".", "").replace(",", ".")));
    if (e.target.value === "") setMonto(0);
  };

  const handleChangeCurrency = (e) => {
    handleChange(e);
    if (e.target.value === 'XRP' || e.target.value === 'BNB-BSC' || e.target.value === 'BTS' || e.target.value === 'EOS') {
      setShowMemoInput(true);
    } else {
      setShowMemoInput(false);
    }
  };

  return (
    <Form>
    <InputContainer>
      <label>{t("deposit.criptomoneda")}:</label>
      <select value={form.cryptocurrency} onChange={handleChangeCurrency} name='cryptocurrency'>
        <option disabled value=''>{t("deposit.selectcripto")}</option>
        {Cryptos.map((Cryptos) => (
           <option value={Cryptos.cryptocurrency}>{`${Cryptos.cryptocurrency} - ${Cryptos.network}`}</option>
        ))}  
      </select>
    </InputContainer>
    {showMemoInput && (
      <InputContainer>
        <label>{t("deposit.memo")}</label>
        <input
          type="text"
          placeholder={t("deposit.memotag")}
          name="memo_tag"
          value={form.memo_tag}
          onChange={handleChange}
        />
      </InputContainer>
    )}
    <InputContainer>
      <label>{t("deposit.walletaddress")}:</label>
      <input
        type="text"
        placeholder={t("deposit.enterwallet")}
        name="wallet_address"
        value={form.wallet_address}
        onChange={handleChange}
      />
    </InputContainer>

    <InputContainer>
      <label>{t("deposit.lbl-amount")}</label>
      <input
        type="text"
        placeholder="0,00"
        name="monto"
        value={form.monto}
        onChange={(e) => handleMonto(e)}
      />

      {moneda === 'MXN' && monto < 150 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 150 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'MXN' && monto > 20000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 20.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'ARS' && monto < 8000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 8.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'ARS' && monto > 1500000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 1.500.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'BRL' && monto < 50 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 50 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'BRL' && monto > 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'CLP' && monto < 20000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 20.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'CLP' && monto > 1000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 1.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'BOB' && monto < 40 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 40 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'BOB' && monto > 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 5.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'COP' && monto < 30000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 30.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'COP' && monto > 4000000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 4.000.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'DOP' && monto < 2000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 2.000 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'DOP' && monto > 50000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 50.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === 'Bs.S' && monto < 100 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 100 VES
          </ErrorSpan>
        )}
        {moneda === 'Bs.S' && monto > 100000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 100.000 VES
          </ErrorSpan>
        )}

        {moneda === 'EUR' && monto < 30 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} 30 {moneda}{" "}
          </ErrorSpan>
        )}
        {moneda === 'EUR' && monto > 3000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} 3.000 {moneda}{" "}
          </ErrorSpan>
        )}

        {moneda === '$' && monto < 10 && blur && (
          <ErrorSpan>
            {t("deposit.amount-greater-than")} {moneda}30{" "}
          </ErrorSpan>
        )}
        {moneda === '$' && monto > 5000 && blur && (
          <ErrorSpan>
            {t("deposit.amount-less-than")} {moneda}3.000{" "}
          </ErrorSpan>
        )}
    </InputContainer>
      <img src={Rcoinspaid} alt='coinspaid' className={'tupa1'} style={{width:'40%', marginLeft: '30%', marginTop: '5%'}}/>
      <img src={COINSPAID} alt='Pasarelas COINSPAID' className={'tupa2'} style={{height: '40px',width:'100%', marginTop: '2%', marginLeft: '0%'}}/>
      <ButtonsContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-back")}
        </Button>
        <Button
          primary={true}
          disabled={loading || (monto < 150 && moneda === 'MXN') || (monto > 20000 && moneda === 'MXN') || (monto < 8000 && moneda === 'ARS') || (monto > 1500000 && moneda === 'ARS') || (monto < 50 && moneda === 'BRL') 
         || (monto > 5000 && moneda === 'BRL') || (monto < 20000 && moneda === 'CLP') || (monto > 1000000 && moneda === 'CLP') || (monto < 40 && moneda === 'BOB') || (monto > 5000 && moneda === 'BOB')
         || (monto < 30000 && moneda === 'COP') || (monto > 4000000 && moneda === 'COP') || (monto < 2000 && moneda === 'DOP') || (monto > 50000 && moneda === 'DOP') || (monto < 100 && moneda === 'Bs.S') || (monto > 100000 && moneda === 'Bs.S')
         || (monto < 30 && moneda === 'EUR') || (monto > 3000 && moneda === 'EUR') || (monto < 30 && moneda === '$') || (monto > 3000 && moneda === '$')}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-next")}
        </Button>
      </ButtonsContainer>
      

    </Form>
  );
};

export default FormCoinspaidRetiro;


